import React, { useState, useEffect, useContext } from "react";
import BackButton from "../components/BackButton"; // Ensure path is correct
import { UserContext } from "../context/UserContext"; // 🔥 Imported Context

function ReferEarn() {
  const [copied, setCopied] = useState(false);
  
  // 🔥 Get Data and Functions from Context
  const { referralData, isReferralLoading, fetchReferralData } = useContext(UserContext);

  // Jab page load ho, data mangwao (Context khud handle karega ki API karni hai ya nahi)
  useEffect(() => {
    fetchReferralData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Use cached data, or show default empty structure if null
  const data = referralData || {
    myReferralCode: "LOADING...",
    totalReferrals: 0,
    totalEarned: 0,
    referredUsers: []
  };

  const steps = [
    { num: "01", title: "Share Code", desc: "Invite via WhatsApp", icon: "share-fill", color: "#8B0000" }, // Maroon
    { num: "02", title: "Friend Joins", desc: "They sign up using code", icon: "person-plus-fill", color: "#f59e0b" }, // Gold
    { num: "03", title: "You Earn", desc: "Get ₹100 Bonus Cash", icon: "cash-coin", color: "#10b981" } // Green
  ];

  const handleCopy = () => {
    navigator.clipboard.writeText(data.myReferralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = () => {
    const shareText = `Play WIN11 Fantasy Cricket with me! Use my invite code *${data.myReferralCode}* to get ₹50 FREE Signup Bonus. Download now!`;
    
    if (navigator.share) {
      navigator.share({
        title: 'Join WIN11 Fantasy',
        text: shareText,
        url: window.location.origin
      }).catch(err => console.log(err));
    } else {
      window.open(`https://wa.me/?text=${encodeURIComponent(shareText + " " + window.location.origin)}`, '_blank');
    }
  };

  // 🔥 PREMIUM SHIMMER LOADING UI (Only shows if it's the first time loading and data is null)
  if (isReferralLoading && !referralData) {
    return (
      <div style={{ minHeight: "100vh", background: "#f8f9fa", paddingBottom: "100px" }} className="placeholder-glow">
        
        {/* Header Shimmer */}
        <div className="position-relative pb-5" style={{ background: "linear-gradient(135deg, #8B0000 0%, #4A0000 100%)", borderBottomLeftRadius: "35px", borderBottomRightRadius: "35px", paddingTop: "10px", boxShadow: "0 10px 20px rgba(139, 0, 0, 0.15)" }}>
          <div className="container-fluid px-3">
            <div className="mt-4 pb-4 text-center">
                <div className="placeholder rounded-circle mb-3" style={{ width: "70px", height: "70px", backgroundColor: "rgba(255,255,255,0.2)" }}></div>
                {/* <h2 className="placeholder col-5 mb-2 rounded" style={{ backgroundColor: "rgba(255,255,255,0.3)", height: "25px" }}></h2> */}
                <br/>
                <p className="placeholder col-8 rounded" style={{ backgroundColor: "rgba(255,255,255,0.2)", height: "15px" }}></p>
            </div>
          </div>
        </div>

        {/* Body Shimmer */}
        <div className="container-fluid px-3 px-md-4" style={{ marginTop: "-45px" }}>
            
            {/* Coupon Card Shimmer */}
            <div className="card border-0 mb-4 shadow-sm" style={{ borderRadius: "20px" }}>
                <div className="card-body p-4 text-center">
                    <span className="placeholder col-4 mb-4 rounded" style={{ height: "12px" }}></span>
                    <div className="p-3 mb-4 rounded d-flex justify-content-between align-items-center" style={{ background: "#f8f9fa" }}>
                         <span className="placeholder col-5 rounded" style={{ height: "25px" }}></span>
                         <span className="placeholder col-3 rounded-pill" style={{ height: "30px" }}></span>
                    </div>
                    <span className="placeholder col-12 rounded-pill" style={{ height: "50px", backgroundColor: "#e2e8f0" }}></span>
                </div>
            </div>

            {/* Stats Shimmer */}
            <div className="row g-3 mb-4">
                {[1, 2].map(i => (
                    <div className="col-6" key={i}>
                        <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
                            <div className="card-body p-3 d-flex flex-column align-items-center">
                                <div className="placeholder rounded-circle mb-2" style={{ width: "45px", height: "45px", backgroundColor: "#e2e8f0" }}></div>
                                <span className="placeholder col-6 mb-1 rounded" style={{ height: "18px" }}></span>
                                <span className="placeholder col-4 rounded" style={{ height: "10px" }}></span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* List Shimmer */}
            <div className="mb-4">
                 <span className="placeholder col-3 mb-3 rounded" style={{ height: "15px" }}></span>
                 <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
                     <div className="card-body p-0">
                         {[1, 2, 3].map(i => (
                             <div key={i} className={`d-flex align-items-center p-3 ${i !== 3 ? 'border-bottom' : ''}`}>
                                 <div className="placeholder rounded-circle me-3" style={{ width: "45px", height: "45px", backgroundColor: "#e2e8f0" }}></div>
                                 <div className="flex-grow-1">
                                     <span className="placeholder col-7 mb-1 d-block rounded" style={{ height: "15px" }}></span>
                                     <span className="placeholder col-4 d-block rounded" style={{ height: "10px" }}></span>
                                 </div>
                             </div>
                         ))}
                     </div>
                 </div>
            </div>

        </div>
      </div>
    );
  }

  // 🔥 MAIN UI (When Data is Loaded or Cached)
  return (
    <div style={{ minHeight: "100vh", background: "#f8f9fa", paddingBottom: "100px" }}>
      
      {/* === HEADER SECTION (Premium Maroon Gradient) === */}
      <div 
        className="position-relative pb-5"
        style={{ 
            background: "linear-gradient(135deg, #8B0000 0%, #4A0000 100%)", // 🔥 Maroon Theme
            borderBottomLeftRadius: "35px", 
            borderBottomRightRadius: "35px",
            paddingTop: "10px",
            boxShadow: "0 10px 20px rgba(139, 0, 0, 0.15)"
        }}
      >
        <div className="container-fluid px-3">
          <BackButton to="/home" label="" className="text-white" />
          
          <div className="text-center text-white mt-2 pb-4">
            <div className="mb-3 d-flex justify-content-center">
                <div style={{
                    background: "rgba(255,255,255,0.1)", 
                    padding: "15px", 
                    borderRadius: "50%",
                    backdropFilter: "blur(5px)"
                }}>
                  <img 
                      src="https://cdn-icons-png.flaticon.com/512/3113/3113054.png" 
                      alt="Gift" 
                      width="70" 
                      style={{ filter: "drop-shadow(0 5px 15px rgba(255,215,0,0.4))" }} // Golden glow
                  />
                </div>
            </div>
            <h2 className="fw-bold mb-1" style={{ letterSpacing: "1px" }}>Refer & Earn</h2>
            <p className="opacity-75 mb-0" style={{fontSize: "0.95rem"}}>
              Invite friends & earn <span className="fw-bold" style={{ color: "#ffd700" }}>₹100 Bonus</span> per friend!
            </p>
          </div>
        </div>
      </div>

      <div className="container-fluid px-3 px-md-4" style={{ marginTop: "-45px" }}>
        
        {/* === REFERRAL CODE CARD (Premium Coupon Style) === */}
        <div className="card border-0 mb-4 text-center overflow-hidden" style={{ borderRadius: "20px", boxShadow: "0 8px 25px rgba(0,0,0,0.08)" }}>
            <div className="card-body p-4">
                <p className="text-muted small fw-bold mb-3 tracking-wide text-uppercase" style={{ letterSpacing: "1.5px" }}>Your Invite Code</p>
                
                <div 
                    className="d-flex align-items-center justify-content-between p-3 mb-4 position-relative"
                    style={{ 
                        background: "#fff5f5", // Light maroon tint
                        border: "2px dashed #8B0000", // Maroon dash
                        borderRadius: "12px" 
                    }}
                >
                    <h3 className="fw-bold mb-0" style={{ letterSpacing: "2px", color: "#8B0000" }}>
                      {data.myReferralCode}
                    </h3>
                    <button 
                        onClick={handleCopy}
                        className={`btn btn-sm fw-bold px-3 rounded-pill transition-all ${copied ? 'btn-success' : 'btn-outline-danger'}`}
                        style={{ 
                            transition: "all 0.3s ease",
                            borderColor: copied ? "" : "#8B0000",
                            color: copied ? "" : "#8B0000"
                        }}
                    >
                        {copied ? <span><i className="bi bi-check2-all"></i> Copied</span> : "Copy"}
                    </button>
                </div>

                <div className="row g-2">
                    <div className="col-12">
                         <button 
                            onClick={handleShare}
                            className="btn w-100 py-3 rounded-pill fw-bold text-white shadow-sm d-flex align-items-center justify-content-center gap-2"
                            style={{ 
                              background: "linear-gradient(90deg, #25D366 0%, #128C7E 100%)", 
                              border: "none",
                              fontSize: "1.05rem"
                            }}
                         >
                            <i className="bi bi-whatsapp fs-5"></i> Share via WhatsApp
                         </button>
                    </div>
                </div>
            </div>
        </div>

        {/* === STATS ROW === */}
        <div className="row g-3 mb-4">
            {[
                { label: "Total Earned", value: `₹${data.totalEarned}`, color: "#f59e0b", icon: "wallet2", bg: "#fffbeb" }, // Gold
                { label: "Friends Joined", value: data.totalReferrals < 10 ? `0${data.totalReferrals}` : data.totalReferrals, color: "#8B0000", icon: "people-fill", bg: "#fff5f5" } // Maroon
            ].map((stat, idx) => (
                <div className="col-6" key={idx}>
                    <div className="card border-0 h-100" style={{ borderRadius: "16px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
                        <div className="card-body p-3 d-flex flex-column align-items-center text-center">
                            <div className="rounded-circle d-flex align-items-center justify-content-center mb-2"
                                 style={{ width: "45px", height: "45px", background: stat.bg, color: stat.color }}>
                                <i className={`bi bi-${stat.icon} fs-5`}></i>
                            </div>
                            <h5 className="fw-bold mb-0 text-dark">{stat.value}</h5>
                            <p className="text-muted small mb-0 fw-bold" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>{stat.label.toUpperCase()}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>

        {/* === HOW IT WORKS === */}
        <div className="mb-4">
             <h6 className="fw-bold text-dark mb-3 ps-1" style={{ letterSpacing: "0.5px" }}>How it Works</h6>
             <div className="card border-0" style={{ borderRadius: "16px", boxShadow: "0 4px 15px rgba(0,0,0,0.03)" }}>
                 <div className="card-body p-0">
                     {steps.map((step, idx) => (
                         <div key={idx} className={`d-flex align-items-center p-3 ${idx !== steps.length - 1 ? 'border-bottom' : ''}`}>
                             <div className="me-3 position-relative">
                                 <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
                                      style={{ width: "48px", height: "48px", background: `${step.color}15`, color: step.color }}>
                                     <i className={`bi bi-${step.icon} fs-5`}></i>
                                 </div>
                             </div>
                             <div className="flex-grow-1">
                                 <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: "0.95rem" }}>{step.title}</h6>
                                 <small className="text-muted" style={{ fontSize: "0.8rem" }}>{step.desc}</small>
                             </div>
                         </div>
                     ))}
                 </div>
             </div>
        </div>

        {/* === RECENT REFERRALS LIST === */}
        <div className="mb-4">
            <h6 className="fw-bold text-dark mb-3 ps-1" style={{ letterSpacing: "0.5px" }}>My Network</h6>
            
            <div className="card border-0" style={{ borderRadius: "16px", boxShadow: "0 4px 15px rgba(0,0,0,0.03)" }}>
                <div className="card-body p-0">
                    {data.referredUsers.length === 0 ? (
                      <div className="text-center p-4">
                        <i className="bi bi-person-x text-muted" style={{ fontSize: "3rem", opacity: "0.5" }}></i>
                        <p className="text-muted mt-2 mb-0 fw-bold">No friends invited yet</p>
                        <small className="text-muted">Share your code to start earning!</small>
                      </div>
                    ) : (
                      data.referredUsers.map((ref, idx) => {
                          const initials = ref.name.split(" ").map((n)=>n[0]).join("").substring(0, 2).toUpperCase();
                          const joinDate = new Date(ref.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });

                          return (
                              <div key={idx} className={`d-flex align-items-center p-3 ${idx !== data.referredUsers.length -1 ? 'border-bottom' : ''}`}>
                                  {/* Avatar with Maroon Tint */}
                                  <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold me-3"
                                        style={{ width: "45px", height: "45px", fontSize: "14px", background: "#fff5f5", color: "#8B0000" }}>
                                      {initials}
                                  </div>
                                  
                                  {/* Info */}
                                  <div className="flex-grow-1">
                                      <h6 className="fw-bold mb-0 text-dark" style={{fontSize: "0.95rem"}}>{ref.name}</h6>
                                      <small className="text-muted" style={{fontSize: "0.75rem"}}>Joined: {joinDate}</small>
                                  </div>

                                  {/* Status */}
                                  <div className="text-end">
                                      <div className="fw-bold text-success">+₹100</div>
                                      <small className="badge rounded-pill bg-success-subtle text-success" style={{fontSize: "10px"}}>
                                          Bonus Added
                                      </small>
                                  </div>
                              </div>
                          )
                      })
                    )}
                </div>
            </div>
        </div>

      </div>
    </div>
  );
}

export default ReferEarn;